import { useCallback, useEffect, useState } from "react";
import { Calendar } from "@/components/ui/calendar";
import { useTheme } from "@/components/Theme";
import {
  calendarDateToMs,
  DateBound,
  msToCalendarDate,
} from "./dateBoundValue";

interface DateSingleCalendarProps {
  date?: number;
  /** Which edge of the day to snap to — "start" for after, "end" for before. Defaults to "start". */
  bound?: DateBound;
  onChange: (date: number) => void;
}

export function DateSingleCalendar({
  date,
  bound = "start",
  onChange,
}: DateSingleCalendarProps) {
  const { isDarkMode } = useTheme();
  const [selected, setSelected] = useState<Date | undefined>(() =>
    msToCalendarDate(date)
  );

  useEffect(() => {
    setSelected(msToCalendarDate(date));
  }, [date]);

  const handleSelect = useCallback(
    (day: Date | undefined) => {
      setSelected(day);
      if (day != null) {
        onChange(calendarDateToMs(day, bound));
      }
    },
    [onChange]
  );

  return (
    <div className={isDarkMode ? "dark" : "light"}>
      <Calendar
        initialFocus
        mode="single"
        defaultMonth={selected}
        selected={selected}
        onSelect={handleSelect}
        numberOfMonths={1}
      />
    </div>
  );
}
